import { CommonService } from 'app/services/common.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../../../../services/common-request-response.service';
import { DataService } from './../../../../../services/data.service';
import { NotificationService } from './../../../../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';




@Component({
  selector: 'app-student-activities-panel',
  templateUrl: './student-activities-panel.component.html',
  styleUrls: ['./student-activities-panel.component.scss']
})
export class StudentActivitiesPanelComponent implements OnDestroy, OnChanges {
  @Input() profileData: any;

  selectedActivityList = [];
  selectedOtherActivityList = [];

  isOtherClub: boolean;
  isOtherActivity: boolean;
  activitiesTouched = false;
  activityClubList = this.dataService.getEntity('Club Activities').item.sort(this.commonService.dynamicSort('id', true));
  activityOtherList = this.dataService.getEntity('Other Club Activities').item.sort(this.commonService.dynamicSort('id', true));

  private destroyed$ = new Subject();

  constructor(
    private notificationService: NotificationService,
    private dataService: DataService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private commonService: CommonService
  ) {
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileData'] !== undefined && changes['profileData'].currentValue !== undefined) {
      this.profileData = changes['profileData'].currentValue || {};
      this.setActivityListData();
    }
  }

  onClubActivityChecked(activity: any) {
    activity.checked = !activity.checked;
    this.activitiesTouched = true;
    this.checkIsOtherClub(activity);

    this.selectedActivityList = this.activityClubList.filter(club => club.checked).map(club => club.id.toString());
    this.commonDataSharedService.studentQuestionaryThreeActivityData.next({ selectedList: this.selectedActivityList });
  }

  onOtherActivityChecked(activity: any) {
    activity.checked = !activity.checked;
    this.activitiesTouched = true;
    this.checkIsOtherActivity(activity);

    this.selectedOtherActivityList = this.activityOtherList.filter(item => item.checked).map(item => item.id.toString());
    this.commonDataSharedService.studentQuestionaryThreeOtherActivityData.next({ selectedList: this.selectedOtherActivityList });
  }

  checkIsOtherClub(activity) {
    if (activity.text === 'Other') {
      this.isOtherClub = activity.checked;

      if (!this.isOtherClub) {
        this.profileData.otherClub = '';
      }
    }
  }

  checkIsOtherActivity(activity) {
    if (activity.text === 'Other') {
      this.isOtherActivity = activity.checked;

      if (!this.isOtherActivity) {
        this.profileData.otherActivity = '';
      }
    }
  }

  clubsOtherTextfieldBlur(item: any) {
    this.activitiesTouched = true;
    this.commonDataSharedService.studentQuestionaryThreeActivityTextData.next({ activityText: item });
  }

  otherActivityTextfieldBlur(item: any) {
    this.activitiesTouched = true;
    this.commonDataSharedService.studentQuestionaryThreeOtherActivityTextData.next({ othActivityText: item });
  }

  setActivityListData() {
    if (this.profileData) {
      const selectedClub = [];
      const selectedOther = [];

      if (this.activityClubList && this.activityClubList.length && this.profileData.clubClassIds && this.profileData.clubClassIds.length) {
        this.activityClubList.forEach(element => {
          if (this.profileData.clubClassIds.includes(element.id + '')) {
            element.checked = true;
            selectedClub.push(element.id + '');
            this.checkIsOtherClub(element);
          }
        });
      }

      if (this.activityOtherList && this.activityOtherList.length && this.profileData.otherActivitiesClassIds && this.profileData.otherActivitiesClassIds.length) {
        this.activityOtherList.forEach(element => {
          if (this.profileData.otherActivitiesClassIds.includes(element.id + '')) {
            element.checked = true;
            selectedOther.push(element.id + '');
            this.checkIsOtherActivity(element);
          }
        });
      }

      this.selectedActivityList = selectedClub;
      this.commonDataSharedService.studentQuestionaryThreeActivityData.next({ selectedList: this.selectedActivityList });
      this.commonDataSharedService.studentQuestionaryThreeOtherActivityTextData.next({ othActivityText: this.profileData.otherClub });

      this.selectedOtherActivityList = selectedOther;
      this.commonDataSharedService.studentQuestionaryThreeOtherActivityData.next({ selectedList: this.selectedOtherActivityList });
      this.commonDataSharedService.studentQuestionaryThreeActivityTextData.next({ activityText: this.profileData.otherActivity });
    }
  }
}
